module.exports = __webpack_public_path__ + "static/media/image8.aea9ed6e.png";